import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions/pedidos';

import AlertGeral from '../../components/Alert/Geral';
import DynamicSelector from '../../components/Lista/DynamicSelector';
import { erpApi } from '../../services/erpApi';

function StatusRecods({ records, admin, order, payment, setNovoStatusPagamento, setNovoStatusEntrega, atualizarFormaPagamentoERP, refreshList }) {
	const [warning, setWarning] = useState(null);
	const [formasPagamento, setFormasPagamento] = useState([]);
	const [formaPagamentoSelecionada, setFormaPagamentoSelecionada] = useState("");
	const [loadingFormasPagamento, setLoadingFormasPagamento] = useState(false);
	const [atualizandoFormaPagamento, setAtualizandoFormaPagamento] = useState(false);

	useEffect(() => {
		carregarFormasPagamento();
	}, []);

	async function carregarFormasPagamento() {
		setLoadingFormasPagamento(true);
		try {
			const response = await erpApi.getFormasPagamento();
			if (response.success) {
				setFormasPagamento(response.data);
			} else {
				setWarning({ status: false, msg: response.error.message || "Erro ao carregar formas de pagamento" });
			}
		} catch (error) {
			setWarning({ status: false, msg: error.message || "Erro ao carregar formas de pagamento" });
		} finally {
			setLoadingFormasPagamento(false);
		}
	}

	function mapearFormaPagamentoParaForma(nomeForma) {
		if (!nomeForma) return "creditCard";
		const nome = String(nomeForma).toLowerCase();
		if (nome.includes("pix")) return "PIX";
		if (nome.includes("paypal")) return "paypal";
		return "creditCard";
	}

	function atualizarFormaPagamento() {
		if (!formaPagamentoSelecionada) {
			return setWarning({ status: false, msg: "Selecione uma forma de pagamento" });
		}
		setWarning(null);
		setAtualizandoFormaPagamento(true);

		const formaSelecionada = formasPagamento.find(f => {
			const id = f.FormasPagamento?.id ?? f.id;
			return String(id) === String(formaPagamentoSelecionada);
		});
		const fp = formaSelecionada?.FormasPagamento ?? formaSelecionada;
		const nomeForma = fp?.nome || fp?.descricao || (formaPagamentoSelecionada ? `Forma ${formaPagamentoSelecionada}` : "");
		const forma = mapearFormaPagamentoParaForma(nomeForma);

		atualizarFormaPagamentoERP(
			formaPagamentoSelecionada,
			forma,
			nomeForma,
			order.pagamento._id || order.pagamento,
			order._id,
			admin.loja,
			(error) => {
				setAtualizandoFormaPagamento(false);
				if(error) return setWarning({ status: false, msg: error.message });
				else {
					setWarning({ status: true, msg: "Forma de pagamento atualizada com sucesso!" });
					refreshList();
				}
			}
		);
	}

	function newStatePayment({ status, justifyText }) {
		setWarning(null);
		if(!status) return setWarning({ aviso: { status: false, msg: "Preencha o campo para enviar um novo status" }});
		
		setNovoStatusPagamento({ status, justifyText: justifyText || null }, order.pagamento._id || order.pagamento, order._id, admin.loja, (error) => {
			if(error) return setWarning({ status: false, msg: error.message });
			else refreshList();
		});
	}

  function newStateDelivery({ status, justifyText }) {
		setWarning(null)
		if(!status) return setWarning({ aviso: { status: false, msg: "Preencha o campo para enviar um novo status" }});
		
		setNovoStatusEntrega({ status, justifyText: justifyText || null }, order.entrega._id, order._id, admin.loja, (error) => {
			if(error) return setWarning({ status: false, msg: error.message })
			else refreshList();
		});
	}

	const TransactionInfo = ({ payment }) => {

		if (!payment || !payment?.card || payment.card.length<=0 || !payment.card[0]) {
			return <div>Nenhuma transação encontrada.</div>;
		}

		const statusMap = {
			paid: "Pago",
			authorized: "Aprovada",
			not_authorized: "Recusada",
			failed: "Falha",
			pending: "Pendente",
			canceled: "Cancelada",
			refunded: "Estornada",
			processing: "Em processamento",
		};

		const cardData = payment.card[0];
		if (!cardData) {
			return <div>Dados do cartão não disponíveis.</div>;
		}

		const { last_transaction, customer, status } = cardData;
		// return (<div></div>)
		if (cardData.payment_method==='credit_card') {
			const lt = last_transaction || null;
			const card = lt?.card || null;
			const acquirer_message = lt?.acquirer_message || null;
			const updated_at = lt?.updated_at || null;
			return (
				<div>
					<h3>Detalhes da Transação {card?.brand || '—'}</h3>
					<p><strong>Última Atualização:</strong> {updated_at ? new Date(updated_at).toLocaleString() : '—'}</p>
					<p><strong>Nome do Titular:</strong> {card?.holder_name || '—'}</p>
					<p><strong>Documento(CPF):</strong> {customer?.document || '—'}</p>
					<p><strong>Últimos 4 dígitos do cartão:</strong> {card?.last_four_digits || '—'}</p>
					{card?.billing_address ? (
						<p><strong>Endereço do cartão:</strong> {card.billing_address.line_1}, {card.billing_address.city}-{card.billing_address.state}, CEP: {card.billing_address.zip_code}</p>
					) : null}
					<p><strong>Status da Transação:</strong> {statusMap[status] || status}</p>
					{status !== "authorized" && acquirer_message && (
						<p><strong>Motivo da Recusa:</strong> {acquirer_message}</p>
					)}
				</div>
			);
		}

		if (cardData.payment_method==='pix') {
			const { updated_at } = last_transaction;
			return (
				<div>
					<h3>Detalhes da Transação PIX</h3>
					<p><strong>Última Atualização:</strong> {new Date(updated_at).toLocaleString()}</p>
					<p><strong>Status da Transação:</strong> {statusMap[status] || status}</p>
					<p><strong>QR Code:</strong> {last_transaction.qr_code}</p>
					<p><strong>QR Code Url:</strong> {last_transaction.qr_code_url}</p>
					<img src={last_transaction.qr_code_url} alt="QR Code for Payment" style={{ width: "200px", height: "200px" }} />
				</div>
			);
		}

		if (cardData?.purchase_units?.[0]?.soft_descriptor) {
			const purchase = cardData?.purchase_units?.[0];
			const payer = cardData?.payer;

			return (
				<div>
					<h3>Detalhes da Transação (PayPal)</h3>
					<p><strong>Última Atualização:</strong> {new Date(cardData?.update_time).toLocaleString()}</p>
					<p><strong>Nome do Pagador:</strong> {payer.name.given_name} {payer.name.surname}</p>
					<p><strong>Email do Pagador:</strong> {payer.email_address}</p>
					<p><strong>País do Pagador:</strong> {payer.address.country_code}</p>
					<p><strong>Valor da Transação:</strong> {purchase.amount.value} {purchase.amount.currency_code}</p>
					<p><strong>Status da Transação:</strong> {statusMap[payment.status] || payment.status}</p>
				</div>
			);
		}

		return (<div></div>)
	};


	if(!records) {
		return <div></div>;
	}else {
		return (
			<>
				<div className="status-container">
					<h2>Status de Pagamento</h2>
					<AlertGeral aviso={warning}/>
					<DynamicSelector available={order.cancelado} type="Pagamento" records={records.pagamento}
									 onAdd={({status, justifyText}) => newStatePayment({status, justifyText})}/>
					<TransactionInfo payment={payment} />
				</div>
				<div className="status-container">
					<h2>Atualizar venda no ERP</h2>
					<div className="status-list">
						<div className="selector">
							<select
								value={formaPagamentoSelecionada}
								onChange={(e) => setFormaPagamentoSelecionada(e.target.value)}
								disabled={loadingFormasPagamento || order.cancelado}
							>
								<option value="">Selecionar forma de Pagamento</option>
								{formasPagamento.map((forma, index) => (
									<option key={index} value={forma.FormasPagamento.id}>
										{forma.FormasPagamento.nome || forma.FormasPagamento.descricao || `Forma ${forma.FormasPagamento.id}`}
									</option>
								))}
							</select>
							<div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
								<button
									onClick={atualizarFormaPagamento}
									disabled={loadingFormasPagamento || !formaPagamentoSelecionada || order.cancelado || atualizandoFormaPagamento}
								>
									{atualizandoFormaPagamento ? "Atualizando..." : "Atualizar"}
								</button>

								{order?.erpId ? (
									<button
										type="button"
										title="Abrir pedido no ERP"
										onClick={() =>
											window.open(
												`https://gestaoclick.com/vendas_produtos/visualizar/${order.erpId}`,
												'_blank',
												'noopener,noreferrer'
											)
										}
										disabled={order.cancelado}
										style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
									>
										<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
											<path d="M14 3h7v7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											<path d="M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											<path d="M21 14v7H3V3h7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
									</button>
								) : (
									<span
										title="Não há pedido cadastrado"
										aria-label="Não há pedido cadastrado"
										style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#b45309' }}
									>
										<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
											<path d="M12 9v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											<path d="M12 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
											<path
												d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
												stroke="currentColor"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</span>
								)}
							</div>
						</div>
						{loadingFormasPagamento && <small>Carregando formas de pagamento...</small>}
					</div>
				</div>
				<div className="status-container">
					<h2>Status de Entrega</h2>
					<AlertGeral aviso={warning}/>
					<DynamicSelector available={order.cancelado} type="Entrega" records={records.entrega}
									 onAdd={({status, justifyText}) => newStateDelivery({status, justifyText})}/>
				</div>
			</>
		)
	}
}

export default connect(null, actions)(StatusRecods);